import { ControlOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getSettings } from '@store/SettingReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { useEffect } from 'react'

const BusinessLoyaltyTierPage = () => {
  const dispatch = useAppDispatch()

  const fetchSettings = () => {
    dispatch(getSettings([SettingKey.BUSINESS_LOYALTY_TIER]))
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  return (
    <Page permissions={Permission.manageBusiness}>
      <FormCard
        title="Business Loyalty Tier"
        description={`This loyalty tier is associated to business profiles upon activation`}
        icon={<ControlOutlined />}
        entity={Entity.setting}
        action={SBRMAction.Update}
        metadata={[
          { key: MetadataKey.Setting, value: SettingKey.BUSINESS_LOYALTY_TIER },
        ]}
      />
    </Page>
  )
}

export default BusinessLoyaltyTierPage
